import { Directive, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {
  ClientBrandingService,
  getCssVarName,
} from './client-branding.service';

/**
 * Apply client branding variables to the dom as css variables.
 */
@Directive({
  selector: '[rdoClientBrandingStyling]',
  standalone: true,
})
export class ClientBrandingStylingDirective implements OnInit {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private clientBrandingService: ClientBrandingService
  ) {}

  ngOnInit() {
    this.clientBrandingService.isReady.subscribe((value) => {
      if (value) {
        this.setCSSVars(this.clientBrandingService.data());
      }
    });
  }

  private setCSSVars(theme: { [key: string]: string }) {
    if (!theme) {
      return;
    }
    Object.keys(theme).forEach((key) => {
      if (key === 'files' || key.includes('mobile')) {
        let name: string;
        let value: string;
        if (key === 'files') {
          if (theme.files && theme.files[0]) {
            name = getCssVarName('logo-url');
            value = (theme.files[0] as any).url;
            this.document.documentElement.style.setProperty(name, value);
          }
        } else {
          name = getCssVarName(key);
          value = theme[key];
          this.document.documentElement.style.setProperty(name, value);
        }
      }
    });
  }
}
